import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./context/I18nContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import { RiskBanner } from "./components/layout/RiskDisclaimer";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import AuthCallback from "./components/layout/AuthCallback";

import Home from "./pages/Home";
import Model from "./pages/Model";
import Invest from "./pages/Invest";
import Simulator from "./pages/Simulator";
import Risks from "./pages/Risks";
import FAQ from "./pages/FAQ";
import Legal from "./pages/Legal";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Qualification from "./pages/Qualification";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Reports from "./pages/Reports";
import ReportViewer from "./pages/ReportViewer";
import DataRoom from "./pages/DataRoom";
import Privacy from "./pages/Privacy";

function AppRouter() {
  const location = useLocation();
  // CRITICAL race-condition guard: detect session_id in URL fragment synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <RiskBanner />
      <Navbar />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/model" element={<Model />} />
          <Route path="/invest" element={<Invest />} />
          <Route path="/simulator" element={<Simulator />} />
          <Route path="/risks" element={<Risks />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />

          {/* Protected */}
          <Route path="/qualification" element={<ProtectedRoute><Qualification /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/dashboard/reports/:reportId" element={<ProtectedRoute><ReportViewer /></ProtectedRoute>} />
          <Route path="/data-room" element={<DataRoom />} />
          <Route path="/checkout/:spvId" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
